<template>
  <div id="formarea">
    <b-row>
      <b-col md="5">
        <b-form-group id="namegroup" label="Name" label-for="namefield">
          <b-form-input id="namefield" v-model="name" type="text" placeholder="Your name"></b-form-input>
        </b-form-group>
        <b-form-group id="titlegroup" label="Title" label-for="titlefield">
          <b-form-input required id="titlefield" v-model="title" type="text" placeholder="Your title"></b-form-input>
        </b-form-group>
        <b-form-group id="deptgroup" label="Department" label-for="deptfield">
          <b-form-select required id="deptfield" v-model="dept" type="text" :options="departments"></b-form-select>
        </b-form-group>
        <b-form-group id="phonegroup" label="Office Phone" label-for="phonefield">
          <b-form-input id="phonefield" v-model="phone" maxlength="12" type="tel" :placeholder="pphone" :formatter="phoneformat"></b-form-input>
        </b-form-group>
        <b-form-group id="emailgroup" label="Email Address" label-for="emailfield">
          <b-form-input id="emailfield" v-model="email" type="email" placeholder="Your email address" :formatter="emailformat"></b-form-input>
        </b-form-group>
        <b-form-group id="bldgroup" label="Building" label-for="bldfield">
          <b-form-select required id="bldfield" v-model="bld" type="text" :options="building"></b-form-select>
        </b-form-group>
        <b-form-group id="roomgroup" label="Room" label-for="roomfield">
          <b-form-input id="roomfield" v-model="room" type="text" placeholder="Room number"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="7">
        <h6>Signature Preview</h6>
        <b-card id="preview">
          <!-- <SigTemplate :sig-name="name" :sig-title="title" :sig-dept="dept" :sig-phone="phone" :sig-email="email"/> -->
          <div id="signature-template">
              <table role="presentation" style="font-size: 14px !important; font-family: Arial, Helvetica, sans-serif; max-width: 600px; width: 100%;"><tr>
              <td style="text-align: center; vertical-align: middle; width: 109px; display: inline-block; max-width: 160px; padding-right: 15px;">
                <span v-show='ddept=="Hardrocker Athletics"'><a href="https://www.sdsmt.edu/"><img src="@/assets/grubby-logo.png" alt="South Dakota Mines Logo" style="padding-bottom: 3px; width: 94px;"></a></span>
                <span v-show='ddept!="Hardrocker Athletics"'><a href="https://www.sdsmt.edu/"><img src="@/assets/esig-logo.png" alt="South Dakota Mines Logo" style="padding-bottom: 3px;"></a></span>
              </td>
              <!-- <td style="text-align: center; vertical-align: middle; width: 40px; display: inline-block;"><img src="@/assets/Gold-Bar.png" height="100%" width="3" alt="Gold Bar Separater"></td> -->
              <td style="text-align: left; display: inline-block;">
              <table style="max-width: 400px; border-left: 2px solid #B3A369; border-top: none; border-right: none; border-bottom: none; vertical-align: middle;">
                <!-- <tr><td>
                  <span>{{ dname }}</span><br />
                  <span><em>{{ dtitle }}</em></span><br />
                  <span>{{ ddept }}</span><br />
                  <span>501 E. Saint Joseph Street, Rapid City, SD 57701</span><br />
                  <span></span>{{ dbld }} {{ droom }}&nbsp;|&nbsp;{{ dphone }}&nbsp;|&nbsp;<a :href="'mailto:'+ email" style="color: #385E9D; text-decoration: none;">{{ demail }}</a><br />
                </td></tr> -->
                <tr style="margin-top: 0; padding-top: 0; ">
                  <td style="color: #002554; font-size: 14px; font-weight: bold; text-align: left; vertical-align: top; padding-top: 0; margin-top: 0;  padding-left: 15px;">{{ dname }}</td></tr>
                <tr><td style="line-height: 16px; font-size: 12px; color: #002554; text-align: left; padding-left: 15px;"><em>{{ dtitle }}</em><br />
                  <!-- <span v-show='ddept=="Department of Chemical & Biological Engineering"'> Karen M. Swindler </span>
                  <span v-show='ddept=="Department of Mechanical Engineering"'> Leslie A. Rose </span> -->
                  {{ ddept }}</td></tr>
                <tr><td style="color: #002554; line-height: 14px; font-size: 12px; padding-top: 5px; text-align: left; padding-left: 15px;">501 E. Saint Joseph Street, Rapid City, SD 57701</td></tr>
                <tr><td style="line-height: 14px; font-size: 12px; color: #385e9d; text-align: left; padding-left: 15px;">{{ dbld }} {{ droom }}&nbsp;|&nbsp;{{ dphone }}&nbsp;|&nbsp;<a :href="'mailto:'+ email" style="color: #385E9D; text-decoration: none;">{{ demail }}</a></td></tr>
                <tr>
                <td v-show='ddept!="Hardrocker Athletics"' style="padding-top: 5px; text-align: left; vertical-align: bottom; padding-left: 15px;">
                 <a href="https://www.facebook.com/SouthDakotaMines/"><img src="@/assets/social/facebook.png" height="27" width="27" alt="South Dakota Mines on Facebook"></a>
                 &nbsp;&nbsp;
                 <a href="https://www.instagram.com/southdakotamines/"><img src="@/assets/social/instagram.png" height="27" width="27" alt="South Dakota Mines on Instagram"></a>
                 &nbsp;&nbsp;
                 <a href="https://www.youtube.com/@gotomines"><img src="@/assets/social/you-tube.png" height="27" width="27" alt="South Dakota Mines on YouTube"></a>
                 &nbsp;&nbsp;
                 <a href="https://www.linkedin.com/school/south-dakota-mines/"><img src="@/assets/social/linked-in.png" height="27" width="27" alt="South Dakota Mines on Linked In"></a>
                </td></tr>
                <!-- Show for Athletics   -->
                <tr>
                <td v-show='ddept=="Hardrocker Athletics"' style="padding-top: 5px; text-align: left; vertical-align: bottom; padding-left: 15px;">
                 <a href="https://www.facebook.com/HardrockerAthletics"><img src="@/assets/social/facebook.png" height="27" width="27" alt="Hardrocker Athletics on Facebook"></a>
                 &nbsp;&nbsp;
                 <a href="https://www.instagram.com/hardrockerathletics"><img src="@/assets/social/instagram.png" height="27" width="27" alt="Hardrocker Athletics on Instagram"></a>
                 &nbsp;&nbsp;
                 <a href="https://www.youtube.com/@SouthDakotaMinesHardrockers"><img src="@/assets/social/you-tube.png" height="27" width="27" alt="Hardrocker Athletics on YouTube"></a>
                 &nbsp;&nbsp;
                 <a href="https://x.com/GoHardrockers"><img src="@/assets/social/x.png" height="27" width="27" alt="South Dakota Mines on X"></a>
                </td></tr>
                <tr><td></td></tr>
              </table>
            </td>
            </tr></table>
          </div>
        </b-card>
        <b-button block size="sm" variant="secondary" @click="onClick">Copy Signature</b-button>
      </b-col>
    </b-row>
    <b-toast id="confirm-copy" variant="dark" title="Signature Copied!" auto-hide>Once the signature preview has been copied to the clipboard. Follow the instructions below to paste it in your email client.</b-toast>  
  </div>
</template>

<script>
export default {
  name: "SignatureForm",
  props: [
  ],
  data() {
    return{
      pname: 'Your Name',
      ptitle: 'Your Title',
      pdept: 'Your Department',
      pphone: 'xxx.xxx.xxxx',
      pemail: 'Your email address',
      pbld: 'Building',
      proom: 'Room #',
      
      name: '',
      title: '',
      dept: null,
      phone: '',
      email: '',
      bld: '',
      room: '',
      
      signature: {},
      
      darkmode: false,
      
      departments: [
        {value: null, text:'-- Select Department --'},
        'Academic Affairs',
        'Arbegast Materials Processing & Joining Laboratory',
        'BHNSFS',
        'Business Services',
        'CAMP',
        'Career Services',
        'Composite & Polymer Engineering Laboratory',
        'Counseling Services',
        'Dean of Students',
        'Department of Chemistry, Biology, & Health Sciences',
        'Department of Civil & Environmental Engineering',
        'Department of Electrical Engineering & Computer Science',
        'Department of Geology & Geological Engineering',
        'Department of Humanities, Arts, & Social Sciences',
        'Department of Industrial Engineering',
        'Department of Materials & Metallurgical Engineering',
        'Department of Mathematics',
        'Department of Mining Engineering & Management',
        'Department of Nanoscience & Biomedical Engineering',
        'Department of Physics',
        'Devereaux Library',
        'Engineering & Mining Experiment Station',
        'Environmental Health & Safety',
        'Facilities, Risk, & Services',
        'Finance & Administration',
        'Financial Aid Office',
        'Graduate Education',
        'Hardrocker Athletics',
        'Human Resources',
        'Information Technology Services',
        'Ivanhoe International Center',
        'Karen M. Swindler Department of Chemical & Biological Engineering',
        'Leslie A. Rose Department of Mechanical Engineering',
        'Marketing & Communications',
        'Military Science',
        'Museum of Geology',
        'Office for Professional Education',
        'Office for Teaching and Learning Excellence',
        'Office of Admissions',
        'Office of the President',
        'Registrar’s Office',
        'Research Affairs',
        'Residence Life',
        'Rocker Shop (Bookstore)',
        'Sponsored Programs',
        'Student Engagement',
        'Student Success',
        'Title IX & Accessibility Services',
        'Veterans Resource Center',
        'Women in Science & Engineering',
      ],

      building: [
        {value: null, text:'-- Select Building --'},
        {value: 'CBEC', text: 'Chemical & Biological Engineering/Chemistry Building'},
        {value: 'CM', text: 'Civil/Mechanical Building'},
        {value: 'CB', text: 'Classroom Building'},
        {value: 'Connolly', text: 'Connolly Hall'},
        {value: 'Dakota', text: 'Dakota Building'},
        {value: 'LIB', text: 'Devereaux Library'},
        {value: 'EEP', text: 'Electrical Engineering/Physics Building'},
        {value: 'Facilities', text: 'Facilities Services'},
        {value: 'Peterson', text: 'Howard Peterson Hall'},
        {value: 'King Center', text: 'King Center'},
        {value: 'PRL', text: 'James E. Martin Paleontology Research Lab'},
        {value: 'McLaury', text: 'McLaury Building'},
        {value: 'Music Center', text: 'Music Center'},
        {value: 'NMI', text: 'Nucor Mineral Industries Building'},
        {value: 'O’Harra', text: 'O’Harra Building'},
        {value: 'PAC', text: 'Pearson Alumni & Conference Center'},
        {value: 'Placer', text: 'Placer Hall'},
        {value: 'Rocker Square I', text: 'Rocker Square I'},
        {value: 'Rocker Square II', text: 'Rocker Square II'},
        {value: 'Surbeck', text: 'Surbeck Center'},
        {value: 'Vanderboom Laboratory for Entrepreneurial Research', text: 'V-Lab'},
      ]
    }
  },
  computed:{
    dname: function() { return this.name ? this.name : this.pname },
    dtitle: function() { return this.title ? this.title : this.ptitle },
    ddept: function() { return this.dept ? this.dept : this.pdept },
    dphone: function() { return this.phone ? this.phone : this.pphone },
    demail: function() { return this.email ? this.email : this.pemail },
    dbld: function() { return this.bld ? this.bld : this.pbld },
    droom: function() { return this.room ? this.room : this.proom },
  },

  filters:{
  },

  methods: { 
    
    caps(val){
      val = val.toString()
      return val.toUpperCase()
    },
    
    emailformat(value){
      value = value.toString()
      return value.replace(/^\w/, this.caps).replace(/\.\w/, this.caps)
    },
    
    phoneformat(value){
      value = value.toString()
      return value.replace(/\D/g,'').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3}.)(\d{3})(\d)/,'$1$2.$3')
    },
    
    onClick() {
      this.$nextTick (() => {
        let el = document.getElementById('signature-template')
        document.getSelection().selectAllChildren(el)
        document.execCommand("copy")
        this.$bvToast.show('confirm-copy')
    })
  },
  
  toggledark(){
    this.darkmode = !this.darkmode
    return (this.darkmode ? 'bg-dark' : 'bg-white')
    }
    
  },
}
</script>

<style scoped>
  .social{
    float: left;
    height: 24px;
    padding-right: 6px;
  }
  .no-underline-link {
    text-decoration: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/SignatureForm.vue